<ng-template [ngIf]="isLoggedIn | async" [ngIfElse]="loggedOut">
  <button
    matRipple
    [matMenuTriggerFor]="profileMenu"
    #profileMenuTrigger="matMenuTrigger"
    cdkClickOutsideBehavior
    color="light"
    class="flex items-start"
  >
    <img
      class="w-9 h-9 rounded-full mt-1"
      [src]="(userState$ | async)?.profilePicture || 'assets/images/avatar.svg'"
      alt="Profile avatar"
    />
    <div class="flex flex-col items-start mt-1" [matTooltip]="userRoles">
      <span class="profile-menu-username text-sm font-medium text-white">{{
        (userState$ | async)?.displayName
      }}</span>
      <span class="profile-menu-username text-xs text-white/70">{{
        (userState$ | async)?.email
      }}</span>
    </div>
    <mat-icon class="text-white hidden lg:block">{{
      profileMenuTrigger.menuOpen ? 'expand_less' : 'expand_more'
    }}</mat-icon>
  </button>
  <mat-menu
    #profileMenu="matMenu"
    (closed)="(!profileMenuTrigger.menuOpen)"
    class="w-56 text-xs mt-2"
  >
    <button mat-menu-item [routerLink]="getProfileRoute() | async">
      My Account
    </button>
    <mat-divider class="mx-4"></mat-divider>
    <button
      mat-menu-item
      [routerLink]="['/company']"
      [queryParams]="{ showAll: true }"
      (click)="onGoToCompanies()"
    >
      My Companies
    </button>
    <mat-divider class="mx-4"></mat-divider>
    <button mat-menu-item (click)="openSubmitFeedbackPopover()">
      Submit Feedback
    </button>
    <mat-divider class="mx-4"></mat-divider>
    <button mat-menu-item [matMenuTriggerFor]="aboutSubMenu">About</button>
    <mat-divider class="mx-4"></mat-divider>
    <button mat-menu-item (click)="logout()" class="text-danger font-bold">
      Log out
    </button>
  </mat-menu>
  <!-- About Submenu -->
  <mat-menu #aboutSubMenu="matMenu" class="w-56 text-xs">
    <button mat-menu-item routerLink="/policy-tos">Terms and Conditions</button>
    <mat-divider class="mx-4"></mat-divider>
    <button mat-menu-item routerLink="/policy-privacy">Privacy Policy</button>
    <mat-divider class="mx-4"></mat-divider>
    <button mat-menu-item routerLink="/policy-refund">Refund Policy</button>
    <mat-divider class="mx-4"></mat-divider>
    <a
      mat-button
      mat-menu-item
      target="_blank"
      href="mailto:support@asylumtix.com"
      class="no-underline hover:text-inherit"
    >
      Sell Tickets Wth Us
    </a>
  </mat-menu>
</ng-template>

<ng-template #loggedOut>
  <div class="flex items-center space-x-2">
    <a
      target="_blank"
      href="mailto:support@asylumtix.com"
      class="text-sm font-medium text-white"
      >Need help?</a
    >
    <mat-icon class="text-white">help</mat-icon>
  </div>
</ng-template>
